import api from './client';
import type { StatsQuery, StatsRow, ClicksQuery, ClicksResponse, ConversionsQuery, ConversionsResponse, ConversionRow } from './tracker-types';

export function getTrackerStats(q: StatsQuery): Promise<StatsRow[]> {
  const params = new URLSearchParams();
  params.set('group_by', q.group_by);
  if (q.from) params.set('from', q.from);
  if (q.to) params.set('to', q.to);
  if (q.campaign_id) params.set('campaign_id', q.campaign_id);
  if (q.label) params.set('label', q.label);
  if (q.flow_id) params.set('flow_id', q.flow_id);
  if (q.offer_id) params.set('offer_id', q.offer_id);
  if (q.partner) params.set('partner', q.partner);
  if (q.countries && q.countries.length) params.set('countries', q.countries.join(','));
  if (q.source_type)      params.set('source_type', q.source_type);
  if (q.source_bundle_id) params.set('source_bundle_id', q.source_bundle_id);
  if (q.source_app_id)    params.set('source_app_id', q.source_app_id);
  if (q.date_basis)       params.set('date_basis', q.date_basis);
  return api.get<StatsRow[]>(`/admin/tracker/stats?${params.toString()}`);
}

export function getTrackerClicks(q: ClicksQuery): Promise<ClicksResponse> {
  const params = new URLSearchParams();
  if (q.from) params.set('from', q.from);
  if (q.to) params.set('to', q.to);
  if (q.campaign_id) params.set('campaign_id', q.campaign_id);
  if (q.label) params.set('label', q.label);
  if (q.flow_id) params.set('flow_id', q.flow_id);
  if (q.offer_id) params.set('offer_id', q.offer_id);
  if (q.countries && q.countries.length) params.set('countries', q.countries.join(','));
  if (q.status) params.set('status', q.status);
  if (q.search) params.set('search', q.search);
  if (q.page) params.set('page', String(q.page));
  if (q.limit) params.set('limit', String(q.limit));
  if (q.source_type)      params.set('source_type', q.source_type);
  if (q.source_bundle_id) params.set('source_bundle_id', q.source_bundle_id);
  if (q.source_app_id)    params.set('source_app_id', q.source_app_id);
  if (q.freelancer)       params.set('freelancer', q.freelancer);
  if (q.google_ads)       params.set('google_ads', q.google_ads);
  if (q.asa)              params.set('asa', q.asa);
  return api.get<ClicksResponse>(`/admin/tracker/stats/clicks?${params.toString()}`);
}

export function getTrackerConversions(q: ConversionsQuery): Promise<ConversionsResponse> {
  const params = new URLSearchParams();
  if (q.from) params.set('from', q.from);
  if (q.to) params.set('to', q.to);
  if (q.campaign_id) params.set('campaign_id', q.campaign_id);
  if (q.label) params.set('label', q.label);
  if (q.flow_id) params.set('flow_id', q.flow_id);
  if (q.offer_id) params.set('offer_id', q.offer_id);
  if (q.countries && q.countries.length) params.set('countries', q.countries.join(','));
  if (q.status) params.set('status', q.status);
  if (q.search) params.set('search', q.search);
  if (q.page) params.set('page', String(q.page));
  if (q.limit) params.set('limit', String(q.limit));
  if (q.google_ads) params.set('google_ads', q.google_ads);
  if (q.asa) params.set('asa', q.asa);
  return api.get<ConversionsResponse>(`/admin/tracker/stats/conversions?${params.toString()}`);
}

export type ConversionPayoutUpdate = Pick<
  ConversionRow,
  'id' | 'payout_cents' | 'original_payout_cents' | 'payout_edited_at' | 'payout_edited_by'
>;

export function updateConversionPayout(id: string, payout_cents: number): Promise<ConversionPayoutUpdate> {
  return api.patch<ConversionPayoutUpdate>(`/admin/tracker/stats/conversions/${id}`, { payout_cents });
}
